"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.elementsSaga = void 0;
var tslib_1 = require("tslib");
var omit_1 = tslib_1.__importDefault(require("lodash/omit"));
var effects_1 = require("redux-saga/effects");
var filterSelectors_1 = require("../filter/filterSelectors");
var loadAttributeSelectors_1 = require("../loadAttribute/loadAttributeSelectors");
var sagas_1 = require("../common/sagas");
var elementsSelectors_1 = require("./elementsSelectors");
var loadElements_1 = require("./loadElements");
/**
 * @internal
 */
function elementsSaga(options) {
    var context, hiddenElements, attribute, attributeFilterDisplayFormRef, staticElements, elementsQueryResult;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(sagas_1.getAttributeFilterContext)];
            case 1:
                context = _a.sent();
                return [4 /*yield*/, effects_1.select(filterSelectors_1.selectHiddenElementsAsAttributeElements)];
            case 2:
                hiddenElements = _a.sent();
                return [4 /*yield*/, effects_1.select(loadAttributeSelectors_1.selectAttribute)];
            case 3:
                attribute = _a.sent();
                return [4 /*yield*/, effects_1.select(filterSelectors_1.selectAttributeFilterDisplayForm)];
            case 4:
                attributeFilterDisplayFormRef = _a.sent();
                return [4 /*yield*/, effects_1.select(elementsSelectors_1.selectStaticElements)];
            case 5:
                staticElements = _a.sent();
                return [4 /*yield*/, effects_1.call(loadElements_1.loadElements, context, tslib_1.__assign({ displayFormRef: attributeFilterDisplayFormRef }, options), {
                        hiddenElements: hiddenElements,
                        attribute: attribute,
                    }, staticElements)];
            case 6:
                elementsQueryResult = _a.sent();
                return [2 /*return*/, {
                        elements: elementsQueryResult.items,
                        totalCount: elementsQueryResult.totalCount,
                        options: omit_1.default(options, "signal"),
                    }];
        }
    });
}
exports.elementsSaga = elementsSaga;
//# sourceMappingURL=elementsSaga.js.map